import {
  GETTING_COMMENTS,
  GOT_COMMENTS,
  GOT_MORE_COMMENTS
} from "../Actions/actionTypes";

import { gotMoreData } from "../utility";

const intialState = {
  loading: false,
  pageNum: 0,
  results: {}
};

const commentsReducer = (preState = intialState, action) => {
  switch (action.type) {
    case GETTING_COMMENTS:
      return { ...preState, loading: action.payload };
    case GOT_COMMENTS:
      return { ...intialState, results: action.payload, pageNum: 1 };
    case GOT_MORE_COMMENTS:
      return gotMoreData(action.payload, preState);
    default:
      return { ...preState };
  }
};

export default commentsReducer;
